import { TAction } from "loop-front";
import { OBook } from "./Model";
import { Reducer } from "redux";
import { BookState, Book } from "./@types";
import utilities from "../../Resources/Utils";

export const Books: Reducer<BookState, TAction> = (state = { mainList: [] }, action) => {
    switch (action.type) {
        case OBook.Actions.LIST_RECEIVED: { return { ...state, mainList: action.data }; }

        // eslint-disable-net-line no-fallthrough
        case OBook.Actions.PUT_ITEM_SUCCESS:
        case OBook.Actions.POST_ITEM_SUCCESS: return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }

        case OBook.Actions.ACTIVITY_POST_SUCCESS: {
            switch (action.activity) {
                case OBook.Activities.TOGGLE_PUBLISH: return { ...state, mainList: utilities.updateItemList(state.mainList || [], action.data, 'PUT') }
                default: return state;
            }
        }

        case OBook.Actions.ITEM_DELETED: return { ...state, mainList: utilities.updateItemList(state.mainList || [], { id: action.additionalDispatchData.deletedItemId } as Book, 'DELETE') }

        default: return state;
    }
}

export default Books;